import React from 'react'
import { CommonSvgContent } from "./CommonSvgContent"
import { ContentLanding } from "./ContentLanding"
import {Link} from 'react-router-dom';

export const Contatti = (props) => {

  const room = props.room;

  const stars = [];
  for (let i = 0; i < 60; i++) {
    // const posx = Math.floor(Math.random() * 100);
    // const posy = Math.floor(Math.random() * 100);
    // const w = Math.floor(Math.random() * 5) + 2;
    stars.push(<div className="star" key={i}  />);
  }

  return(
    <div className="pages contatti" >
      {stars}

      <div className='logoMuseo'>
        <CommonSvgContent stringToRet="logoMuseo" />
      </div>

      <div className='collaborazione'>
        <p>In collaborazione con</p>
        <h3>INAF-Osservatorio<br />
        Astronomico<br />
        di Brera </h3>
      </div>


      <div className='logo'>
        <Link to="/"><ContentLanding stringToRet="logo" /></Link>
      </div>

      <div className="mars">
        <ContentLanding stringToRet="mars" />
      </div>

      <div className="content">

        <h1>Contatti</h1>

        <p>Per informazioni e assistenza tecnica scrivi a <a className="under" href="mailto:escape@museoscienza.it">escape@museoscienza.it</a></p>

        <Link className="btn btn-danger backTo" to="/">Torna</Link>

      </div>


    </div>
  )
}
